import { InfoCircleOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const StyledDashboardCollapse = styled(Collapse)`
    border: none;
    width: 100%;

    .ant-collapse-content-box {
        padding: 0px !important;
        background-color: ${(props) =>
            props.theme.collapseHeaderBackground} !important;
        border-radius: 0 0 8px 8px !important;
    }

    .ant-collapse-item {
        background-color: transparent !important;
    }
    .ant-collapse-header {
        padding: 14px !important;
        border-radius: 8px !important;
        background-color: ${(props) =>
            props.theme.collapseHeaderBackground} !important;
    }

    .ant-collapse-item-active {
        .ant-collapse-header {
            border-radius: 8px 8px 0 0 !important;
        }
    }
`;

export const StyledDashboardCollapseList = styled(FlexContainer)`
    padding: 20px;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    div:last-child {
        padding: 0 !important;
        border: none !important;
    }
`;

export const StyledDashboardCollapseListItem = styled(FlexContainer)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
`;

export const StyledInfoIcon = styled(InfoCircleOutlined)`
    color: ${(props) => props.theme.primaryTypographyColor};
    font-size: 24px;
    cursor: pointer;
`;
